import { EventResultItem } from "../types";

import { Card, Heading, Link, Paragraph } from "@digdir/designsystemet-react";
import { LocationPinFillIcon } from "@navikt/aksel-icons";

const EventCard = (props: EventResultItem) => {
  const { url, linkText, eventName, eventLocation } = props;

  return (
    <Card>
      <Card.Block>
        <Heading level={2}>
          <Link href={url} rel="noopener noreferrer">
            {linkText || eventName}
          </Link>
        </Heading>
        {eventName && <Paragraph>{eventName}</Paragraph>}
        {eventLocation && (
          <Paragraph>
            <LocationPinFillIcon aria-hidden="true" /> {eventLocation}
          </Paragraph>
        )}
      </Card.Block>
    </Card>
  );
};

export default EventCard;
